import { useQuery } from 'react-query';

import { PageBoundingBox } from '../../../../backend/src/matter/fact/fact-bounding-box';
import { APIBaseChronos } from '@/api/hosts';
import { ApiError, QueryEntity } from '@/api/types';
import useGetFetchConfig from '@/api/useGetFetchConfig';

export interface KimThreadFileResponse {
  id: string;
  name: string;
  extension: string;
  url: string;
  chunk: {
    id: string;
    content: string;
    boundingBox: PageBoundingBox;
  } | null;
}

interface UseGetKimThreadFileArgs {
  matterId?: string;
  subsetId?: string;
  threadId?: string;
  chunkId?: string | null;
  fileId?: string | null;
}

export const useGetKimThreadFile = ({ matterId, subsetId, threadId, chunkId, fileId }: UseGetKimThreadFileArgs) => {
  const { fetchConfigGET } = useGetFetchConfig();

  const url =
    chunkId != null
      ? `${APIBaseChronos}/api/matter/${matterId}/subset/${subsetId}/kim/threads/${threadId}/file-chunks/${chunkId}`
      : `${APIBaseChronos}/api/matter/${matterId}/subset/${subsetId}/kim/threads/${threadId}/files/${fileId}`;

  return useQuery<KimThreadFileResponse, ApiError>(
    [QueryEntity.KimThreadFile, { chunkId, fileId }],
    async () => {
      const res = await fetch(url, fetchConfigGET);
      if (!res.ok) {
        const error = await res.json();
        throw new ApiError(res.status, error.message);
      }
      return res.json();
    },
    {
      enabled: !!matterId && !!subsetId && !!threadId && (!!chunkId || !!fileId),
      refetchOnWindowFocus: false,
      retry: (failureCount, error) => error.code !== 404 && failureCount < 3,
    },
  );
};
